export default "/images/copy_link.svg?79312e6cab0129ca024c360c0a5629d2";